// extracted by mini-css-extract-plugin
export default {"container":"Navbar_container__dA4Dw","home":"Navbar_home__8-9Kb","about":"Navbar_about__U+nWh","favorites":"Navbar_favorites__2b1mq","logOut":"Navbar_logOut__+1NSL"};